module.exports = __webpack_public_path__ + "roboto-bold-webfont-4cbd1966fc397282fa35d69070782b80.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-bold-webfont.svg
// module id = 835
// module chunks = 76